import { Stack, Typography } from '@common-components';
import { messages } from 'i18n';
import { Market } from 'types';

interface WorkingOnBannerProps {
  selectedMarket: Market | null;
}

export default function WorkingOnBanner({ selectedMarket }: WorkingOnBannerProps) {
  if (!selectedMarket) {
    return null;
  }

  return (
    <Stack direction="row" gap={0.5}>
      <Typography variant="body2">{messages.submissionQueuePage.workingOn}</Typography>
      <Typography variant="body2Bold">{selectedMarket.organizationName}</Typography>
    </Stack>
  );
}
